/* eslint-disable no-unused-vars */
import React, { useEffect, Suspense, useState } from "react";
import { BrowserRouter, Routes, Route, Router } from "react-router-dom";
import { ConfigProvider, Spin } from "antd";
import ErrorBoundary from "./errorBoundary/ErrorBoundary";
import { configureAmplify } from "../src/views/Auth/auth";
import MainLayout from "./views/MainLayout";
import { routeList } from "../src/config/routes";
import { commonRoutes } from "../src/config/commonRoutes";
import { globalPath } from "./config/globalPaths";
import { CopilotKit } from "@copilotkit/react-core";
import "@copilotkit/react-ui/styles.css";
const PageNotFound = React.lazy(() => import("./views/404"));
import "antd/dist/antd.css";
import "./App.scss";
import { APIs, getPremiseId } from "./utils/worker";
import constants from "./constants/constants";
import { readAuthCookies, clearAuthData } from "./utils/authUtils";

const App = () => {
  const [roles, setRoles] = useState();
  const [userInfo, setUserInfo] = useState(
    localStorage.getItem("loggedOutTime")
  );

  useEffect(() => {
    configureAmplify(true);
    // Sanitize localStorage: remove any keys with value "undefined" string
    try {
      Object.keys(localStorage).forEach((key) => {
        if (localStorage.getItem(key) === "undefined") {
          localStorage.removeItem(key);
        }
      });
    } catch (e) {
      console.error("Error sanitizing localStorage", e);
    }
  }, []);

  useEffect(() => {
    let userInfo = localStorage.getItem("loggedOutTime");
    let getRols = null;
    try {
      const storedUserInfo = localStorage.getItem("userinfo");
      if (storedUserInfo && storedUserInfo !== "undefined") {
        getRols = JSON.parse(storedUserInfo);
      }
    } catch (e) {
      console.error("Error parsing userinfo from local storage", e);
    }

    const getRole = getRols?.roles?.[0]?.replace(/.*_/, "");

    try {
      if (userInfo && userInfo !== "undefined") {
        setUserInfo(JSON.parse(userInfo));
      }
    } catch (e) {
      console.error("Error parsing userInfo(loggedOutTime)", e);
    }
    setRoles(getRols);
    // if (
    //   !globalPath.includes(window.location.pathname) &&
    //   getRole === "HUBADMIN"
    // ) {
    //   getTodaysData();
    // }
  }, []);

  useEffect(() => {
    if (!globalPath.includes(window.location.pathname)) {
      sessionOut();
    }
  }, []);

  useEffect(() => {
    let loc = window.location.pathname;
    let check = loc?.includes("view-client");
    if (check) {
      localStorage.setItem("viewClient", loc);
    }
  }, []);

  const sessionOut = () => {
    setInterval(() => {
      const date = new Date();

      // 1. Check if session has expired via timestamp
      const isExpired = date.getTime() >= userInfo;

      // 2. Check if cookies are missing (Source of Truth)
      // This allows syncing login/logout across multiple apps on the same domain
      const tokenData = readAuthCookies();
      const isCookiesMissing = !tokenData || (!tokenData.id_token && !tokenData.accessToken);

      if (isExpired || isCookiesMissing) {
        console.log(`Session terminated: ${isExpired ? "Expired" : "Cookies missing"}`);
        // Session expired or cookies missing - redirect to logout URL
        const url = localStorage.getItem("viewClient");

        // Use centralized clearAuthData to wipe everything
        clearAuthData();

        if (url) {
          localStorage.setItem("viewClient", url);
        }

        // Redirect using static constant value
        window.location.href = constants.LOGOUT_REDIRECT_URL;
      }
    }, 2000); // 2-second check interval
  };
  let eventSource = undefined;

  const premiseId = getPremiseId();
  const { baseURL } = APIs;

  // const getTodaysData = async () => {
  //   const a = premiseId.split("Bearer")[1];
  //   eventSource = new EventSource(
  //     `${baseURL}/hubops-report-service/v1/dashboard/${+a}`
  //   );

  //   eventSource.onmessage = (event) => {
  //     const data = JSON.parse(event.data);
  //     if (data) {
  //       // const array = dataConvertTOArray(data);
  //       sessionStorage.setItem("myValue", JSON.stringify(data));
  //     }
  //   };
  // };

  const dynamicRoutes = () => {
    let temp = [];
    routeList.map((item, index) => {
      item.role.some((rt) => {
        if (roles && roles?.roles?.includes(rt)) {
          temp.push(
            <Route
              exact
              key={`route_${index}`}
              path={item.route}
              element={<item.component />}
            />
          );
        }
      });
    });

    return temp;
  };

  const globalRoutes = () => {
    let temp = [];
    commonRoutes.map((item, index) => {
      temp.push(
        <Route
          exact
          key={`route_${index}`}
          path={item.route}
          element={<item.component />}
        />
      );
    });

    return temp;
  };

  return (
    <CopilotKit
      publicApiKey={process.env.REACT_APP_OPENAI_API_KEY || "ck_pub_b3ec78f162d3a78f87d6f9935d1cfc3f"}
    >
      <ConfigProvider>
        <BrowserRouter basename="/">
          <MainLayout
            component={
              <Suspense fallback={
                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                  width: "100vw",
                }}>
                  <Spin size="large" tip="Loading..." />
                </div>
              }>
                <ErrorBoundary>
                  <Routes>
                    <>
                      {globalRoutes()}
                      <Route path="*" element={<PageNotFound />} />
                      {dynamicRoutes()}
                    </>
                  </Routes>
                </ErrorBoundary>
              </Suspense>
            }
          />
        </BrowserRouter>
      </ConfigProvider>
    </CopilotKit>
  );
};

export default App;
